/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Skeleton } from '@/components/ui/skeleton';

/** Mirrors the image and centred detail layout of the feature ProductCard. */
export const ProductCardSkeleton = () => (
    <article
        data-slot="product-card-skeleton"
        className="flex w-full min-w-0 flex-col overflow-hidden border-r border-b border-snk-greige bg-background"
        aria-hidden="true">
        <Skeleton className="aspect-square w-full [--ui-radius:0px]" />
        {/* Mobile CTA sits under the image; desktop reveals it over the image on hover. */}
        <Skeleton className="mx-4 mt-2 h-9 [--ui-radius:0px] md:hidden" />
        <div className="flex w-full flex-col items-center gap-2 px-4 pb-4 pt-2">
            <Skeleton className="h-4 w-1/3 [--ui-radius:0px]" />
            <Skeleton className="h-4 w-3/4 [--ui-radius:0px]" />
            <Skeleton className="h-4 w-1/4 [--ui-radius:0px]" />
            <Skeleton className="h-6 w-1/2 [--ui-radius:0px]" />
            <Skeleton className="h-4 w-1/3 [--ui-radius:0px]" />
        </div>
    </article>
);
